import { CredentialType, CredentialField } from '../types';

/**
 * Templates de champs pré-définis pour chaque type d'identifiant
 * Ces templates sont utilisés pour pré-remplir le formulaire de création
 */
export const CREDENTIAL_FIELD_TEMPLATES: Record<
  CredentialType,
  CredentialField[]
> = {
  urssaf: [
    {
      label: 'Identifiant',
      value: '',
      type: 'text',
      sensitive: false,
    },
    {
      label: 'Mot de passe',
      value: '',
      type: 'password',
      sensitive: true,
    },
  ],

  'net-entreprise': [
    {
      label: 'SIRET',
      value: '',
      type: 'text',
      sensitive: false,
    },
    {
      label: 'Nom',
      value: '',
      type: 'text',
      sensitive: false,
    },
    {
      label: 'Prénom',
      value: '',
      type: 'text',
      sensitive: false,
    },
    {
      label: 'Mot de passe',
      value: '',
      type: 'password',
      sensitive: true,
    },
  ],

  other: [
    {
      label: 'Identifiant',
      value: '',
      type: 'text',
      sensitive: false,
    },
    {
      label: 'Mot de passe',
      value: '',
      type: 'password',
      sensitive: true,
    },
  ],
};

/**
 * Labels français pour les types d'identifiants
 */
export const CREDENTIAL_TYPE_LABELS: Record<CredentialType, string> = {
  urssaf: 'URSSAF',
  'net-entreprise': 'Net-Entreprise',
  other: 'Autre',
};

/**
 * Descriptions pour les types d'identifiants
 */
export const CREDENTIAL_TYPE_DESCRIPTIONS: Record<CredentialType, string> = {
  urssaf: 'Identifiants de connexion URSSAF',
  'net-entreprise': 'Identifiants Net-Entreprise (SIRET, nom, prénom)',
  other: 'Autre type d\'identifiant personnalisé',
};
